export default "__VITE_ASSET__DLgdTaBV__"